import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Marketplace product grid pagination controls.
 * Extracted from MarketplaceHome.jsx (Session 30, PD-2).
 *
 * Behavior: previous/next arrows + a 5-page window centered around the
 * current page, with ellipses & first/last shortcuts when needed.
 */
export function MarketplacePagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + 4);
  if (end - start < 4) start = Math.max(1, end - 4);

  if (start > 1) {
    pages.push(
      <button
        key={1}
        onClick={() => onChange(1)}
        style={{ padding: "8px 12px", borderRadius: 8, border: "none", background: "transparent", color: "#f5f0e8", cursor: "pointer", fontSize: 13 }}
      >
        1
      </button>
    );
    if (start > 2) {
      pages.push(
        <span key="ds" style={{ color: "rgba(245,240,232,0.2)", fontSize: 13 }}>...</span>
      );
    }
  }

  for (let i = start; i <= end; i++) {
    const isActive = i === page;
    pages.push(
      <button
        key={i}
        onClick={() => onChange(i)}
        data-testid={`pagination-page-${i}`}
        style={{
          padding: "8px 12px", borderRadius: 8, fontSize: 13,
          border: isActive ? "1px solid rgba(201,168,76,0.3)" : "1px solid transparent",
          background: isActive ? "rgba(201,168,76,0.12)" : "transparent",
          color: isActive ? "#c9a84c" : "#f5f0e8",
          cursor: "pointer", fontWeight: isActive ? 700 : 400,
          transition: "background 0.15s",
        }}
      >
        {i}
      </button>
    );
  }

  if (end < totalPages) {
    if (end < totalPages - 1) {
      pages.push(
        <span key="de" style={{ color: "rgba(245,240,232,0.2)", fontSize: 13 }}>...</span>
      );
    }
    pages.push(
      <button
        key={totalPages}
        onClick={() => onChange(totalPages)}
        style={{ padding: "8px 12px", borderRadius: 8, border: "none", background: "transparent", color: "#f5f0e8", cursor: "pointer", fontSize: 13 }}
      >
        {totalPages}
      </button>
    );
  }

  return (
    <div
      style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        gap: 6, marginTop: 24, paddingBottom: 8,
      }}
      data-testid="marketplace-pagination"
    >
      <button
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        data-testid="pagination-prev"
        style={{
          padding: "8px 14px", borderRadius: 8, border: "1px solid rgba(255,255,255,0.08)",
          background: "rgba(255,255,255,0.03)", color: page === 1 ? "rgba(245,240,232,0.2)" : "#f5f0e8",
          cursor: page === 1 ? "default" : "pointer", fontSize: 13,
        }}
      >
        <ChevronLeft size={14} />
      </button>

      {pages}

      <button
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        data-testid="pagination-next"
        style={{
          padding: "8px 14px", borderRadius: 8, border: "1px solid rgba(255,255,255,0.08)",
          background: "rgba(255,255,255,0.03)", color: page === totalPages ? "rgba(245,240,232,0.2)" : "#f5f0e8",
          cursor: page === totalPages ? "default" : "pointer", fontSize: 13,
        }}
      >
        <ChevronRight size={14} />
      </button>
    </div>
  );
}
